import React, { createContext, useContext } from 'react';
var UtilityContext = createContext({ utility: null });
var UtilityProvider = function (_a) {
    var children = _a.children, utility = _a.utility;
    var value = utility;
    return React.createElement(UtilityContext.Provider, { value: value }, children);
};
var useUtility = function () {
    var utility = useContext(UtilityContext);
    if (utility === undefined) {
        throw new Error('useUtility must be used within a UtilityContext');
    }
    return utility;
};
export { UtilityProvider, useUtility };
